import * as BABYLON from '@babylonjs/core'
import React from 'react'

function getShaderMat(scene) {
    var shaderMaterial = new BABYLON.ShaderMaterial("shader", scene, "./Shaders/unlit", {
        attributes: ["position", "uv"],
        uniforms: ["worldViewProjection", "textureSampler"]
    });

    return shaderMaterial;
}

BABYLON.Effect.ShadersStore["unlit-vert"] = `
    precision highp float;
    attribute vec3 position;
    attribute vec2 uv;
    varying vec2 vUV;
    
    uniform mat4 worldViewProjection;
    
    void main() {
        vUV = uv;
        gl_Position = worldViewProjection * vec4(position, 1.0);
    }
`;;
BABYLON.Effect.ShadersStore["unlit-frag"] = `
    precision highp float;
    varying vec2 vUV;
    uniform sampler2D textureSampler;

    void main() {
        vec4 textureColor = texture2D(textureSampler, vUV);
        gl_FragColor = textureColor;
    }
`;
/*
export var tag_shader_unlit = <React.Fragment>
    <script type="application/vertexShader" id="shader-unlit-vert">{src_unlit_vert}</script>
    <script type="application/fragmentShader" id="shader-unlit-frag">{src_unlit_frag}</script>
</React.Fragment>*/

export default getShaderMat;